import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/AdminGallery.css";
import { useNavigate } from "react-router-dom";

const AdminGallery = () => {
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [index, setIndex] = useState("");
  const [mode, setMode] = useState("insert");
    const navigate = useNavigate();


  const API_BASE = "https://kingdomhomesapi.onrender.com/api/gallery";
  // const API_BASE = "http://localhost:5002/api/gallery";

  useEffect(() => {
  const token = sessionStorage.getItem("adminToken");
  if (!token) {
    navigate("/login"); // redirect if not logged in
  }
}, [navigate]);

  const fetchImages = async () => {
    try {
      const res = await axios.get(API_BASE);
      setImages(res.data);
    } catch (err) {
      console.error("Error fetching images:", err);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  const uploadImage = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please select an image");

    const formData = new FormData();
    formData.append("image", file);
    formData.append("index", index);
    formData.append("mode", mode);

    try {
      await axios.post(`${API_BASE}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setFile(null);
      setIndex("");
      fetchImages();
    } catch (err) {
      console.error("Error uploading image:", err);
      alert("Failed to upload or replace image");
    }
  };

  const deleteImage = async (id) => {
    try {
      await axios.delete(`${API_BASE}/${id}`);
      fetchImages();
    } catch (err) {
      console.error("Error deleting image:", err);
      alert("Failed to delete image");
    }
  };

  return (
    <div className="admin-gallery">
      <h2>Admin Panel – Manage Gallery</h2>
      <form onSubmit={uploadImage} className="upload-form">
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files[0])}
        />
        <input
          type="number"
          min="0"
          placeholder="Index (e.g. 5)"
          value={index}
          onChange={(e) => setIndex(e.target.value)}
        />
        <select value={mode} onChange={(e) => setMode(e.target.value)}>
          <option value="insert">Insert</option>
          <option value="replace">Replace</option>
        </select>
        <button type="submit">Upload</button>
      </form>

      <div className="gallery-grid">
        {images.length > 0 ? (
          images.map((img, i) => (
            <div key={img.id} className="admin-card">
              <img src={img.url} alt={`Gallery ${i}`} loading="lazy" />
              <p className="index-label">Index: {i}</p>
              <button onClick={() => deleteImage(img.id)}>Delete</button>
            </div>
          ))
        ) : (
          <p>No images found</p>
        )}
      </div>
    </div>
  );
};

export default AdminGallery;
